import React from "react";

// Define the type for the component's props if you wanted to make the URL dynamic
interface MetabaseDashboardEmbedProps {
  // If you want to allow different URLs, define them here:
  // srcUrl: string;
  // title: string;
}

const MetabaseDashboard: React.FC<MetabaseDashboardEmbedProps> = () => {
  const embedUrl =
    "https://intact-angler.metabaseapp.com/public/dashboard/d2be78c3-d577-45b6-9410-4c8686127f65";

  return (
    <iframe
      src={embedUrl}
      title="Metabase Dashboard Player"
      frameBorder="0"
      allowFullScreen
      style={{ width: "100%", height: "100vh", border: "none" }}
    ></iframe>
  );
};

export default MetabaseDashboard;
